<template>
  <section class="container__button">
    <button
      @click="btnAbort"
      class="container__button-close"
      :class="{ 'with-border': showBorder }"
    >
      <i :style="`font-size: ${fontSize}px`" class="fa fa-eye"></i>
    </button>
  </section>
</template>

<script>
export default {
  name: "ButtonClose",

  data() {
    return {};
  },
  props: {
    fontSize: { type: String, required: false, default: "20" },
    showBorder: { type: Boolean, required: false, default: true }
  },
  methods: {
    btnAbort() {
      this.$emit("btnAbort");
    }
  }
};
</script>

<style scoped>
.container__button {
  color: var(--textactive);
  display: flex;
  width: 90%;
  max-width: 22px;
  height: 90%;
  max-height: 22px;
  z-index: 1;
}
.container__button-close {
  display: flex;
  width: 90%;
  height: 90%;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: none; /* sin borde por defecto */
}
.container__button-close.with-border {
  border: 1px solid var(--lightbackground2);
}
.container__button-close:hover {
  color: var(--textactive-2);
  transform: scale(1.1);
  background: var(--dark-expo-alpha);
  border: 1px solid var(--expo);
}
</style>
